import { takeEvery, put, select, call } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { stopSubmit, startSubmit } from 'redux-form/immutable'
import actionTypes from '../actionTypes'
import actions from '../actions'
import selectors from '../selectors'
import { showError, showSuccess } from '../../toastr/utils'
import makeAPIRequest from '../../api/sagas'
import { ORG_INACTIVE_NOTIFICATIONS_ENDPOINT } from 'app/constants/api/orgInactiveNotifications'
import { ORG_INACTIVE_NOTIFICATIONS_EDIT_FORM as FORM_NAME } from 'app/constants/orgInactiveNotifications'
import { ORG_INACTIVE_NOTIFICATION_UPDATE_SUCCESS } from 'app/constants/toastrMessages'
import { getViewOrganizationSettingsId } from '../../organizations/selectors'

export default function* patchSaga() {
  yield takeEvery(actionTypes.ORG_INACTIVE_NOTIFICATIONS.PATCH.REQUEST, handlePatchRequest)
}

export function* handlePatchRequest({ payload: { data: values } }) {
  try {
    const pending = yield select(selectors.getPendingPatch)
    if (!pending) {
      yield put(startSubmit(FORM_NAME))
      yield put(actions.setPending('patch', true))
      const orgId = yield select(getViewOrganizationSettingsId)
      yield call(makeAPIRequest, `${ORG_INACTIVE_NOTIFICATIONS_ENDPOINT(orgId)}/${values.id}`, {
        method: 'PUT',
        data: values,
      })
      yield put(actions.orgInactiveNotifications.patch.success(values))
      showSuccess({ content: ORG_INACTIVE_NOTIFICATION_UPDATE_SUCCESS })
      yield put(push(`/organizations/${orgId}/settings/inactive-notifications/`))
    }
  } catch (error) {
    showError()
    yield put(actions.orgInactiveNotifications.patch.fail(error))
  } finally {
    yield stopSubmit(FORM_NAME)
  }
}
